import { createRoute } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";
import { Route as rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/connected",
  component: ConnectedPage,
});

/** Landing page after a patient finishes the hosted flow started from an AI chat. */
function ConnectedPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <img src="/assets/medblocks.webp" alt="Medblocks" className="size-16 object-contain" />
      <CheckCircle2 className="size-10 text-green-600" />
      <h1 className="text-2xl font-semibold">You're all set</h1>
      <p className="max-w-sm text-muted-foreground">
        Your health system is being linked to your workspace. You can close this tab and return to your chat.
      </p>
    </div>
  );
}
